import { component } from 'picoapp'
import $ from 'quantdom'
import { get, post } from '../lib/ajax'

export default component((node) => {
  var hasAnsweredQuestions = false
  const mainQuizParentDiv = document.querySelector('.skin-quiz-custom-section')
  //helps make universal bullets
  function bulletMaker(bulletText) {
    return `
    <div class="tw-inline-flex tw-items-center tw-gap-1 tw-text-[14px]/[24px] md:tw-text-[16px]/[24px] tw-font-light tw-bg-[#EDEDED] tw-rounded-full tw-px-[12px] tw-py-[6px] tw-whitespace-pre recommended-skin-type">
      ${bulletText}
    </div>
    `
  }

  //definitions to skin types to quiz answers
  var skinTypeDefinitions = {
    'Skin Type': 114371,
    'Skin Tone': 114373,
  }

  function waitForKlaviyo(email, newItems) {
    if (!_learnq || !_learnq.identify || !_learnq.track) {
      setTimeout(function () {
        waitForKlaviyo(email, newItems)
      }, 250)
    } else {
      var identifySettings = Object.assign({}, { email: email }, newItems)

      _learnq.identify(identifySettings, function () {})
      _learnq.push(['track', 'Presidio - Quiz: Results Rec', newItems])
    }
  }

  //api docs https://support.quizkitapp.com/faqs/how-do-i-add-my-own-css-and-javascript-on-top-of-quiz-kit

  document.addEventListener('quizKitQuestionLoaded', function (e) {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    //}, 100)
    //console.log('quizKitQuestionLoaded', e)
    heap.track('Quiz Kit Question View', {
      question: e.detail.name,
    })

    hasAnsweredQuestions = true
  })

  //on results rendered e contains details about the quiz
  document.addEventListener('quizKitResultsPageLoaded', function (e) {
    debugger;
    if (e.detail) {
      // unhide sections below the skin quiz custom section
      mainQuizParentDiv?.classList.add('visible-results')
      // Function to format the string
      function createAnswersValue(data) {
        return data
          .map((item, index) => {
            const answers = item.selectedAnswers.map((answer) => answer.value).join(', ')

            return `${item.questionTitle}: ${answers}`
          })
          .join('; ')
      }

      // Generate the formatted string

      const quizKitAnswers = createAnswersValue(e.detail.answers).replace(/\u003Cbr\u003E\n/g, '')

      window.scrollTo({ top: 0, behavior: 'smooth' })
      //populate data with info

      //hide quiz
      var quizKit = document.querySelector('[data-quiz-kit-key]')
      if (quizKit) quizKit.classList.add('hidden-results')

      //show results
      var quizResults = document.querySelector('.quiz-results')
      if (quizResults) quizResults.classList.remove('hidden-results')

      console.log('quizKitResultsPageLoaded', e.detail)

      $(node).find('.recommendation-holder').html('')

      //dynamic block insertion based on results
      if (e.detail.result && e.detail.result.contentBlocks) {
        //gets all heading objects for product dynamic content
        var headingsObjects = Object.keys(e.detail.result.contentBlocks)
          .filter((key) => key.startsWith('headings'))
          .map((key) => e.detail.result.contentBlocks[key])
          .filter((key) => key['title'].indexOf('Your results are in') === -1)

        //console.log('headingsObjects', headingsObjects)

        //gets the html for this section to reuse for all recommendations
        get('/?sections=skin-quiz-product')
          .then((res) => {
            //iterate through each recommendation
            headingsObjects.forEach((headingItem, index) => {
              //info to populate the section
              var producttext = headingItem['description']
              // Access the productIds object
              const productIds = e.detail.result.productIds
              const marketingFields = e.detail.result.marketingFields
              let productInfo
              if (marketingFields.title) {
                const productTitleGroup = marketingFields.title.split('|').map((group) => group.trim())
                if (productTitleGroup[index]) {
                  productInfo = e.detail.recommendedProducts.find((x) => x.title == productTitleGroup[index])
                }
              } else {
                // Get the keys in the correct order
                const orderedKeys = Object.keys(productIds)
                var currentProductId = orderedKeys[index]
                 productInfo = e.detail.recommendedProducts.find((x) => x.id == currentProductId)
              }
              if (productInfo) {
                console.log('productInfo', productInfo)
                const parser = new DOMParser()
                const doc = parser.parseFromString(res['skin-quiz-product'], 'text/html')

                //top reccomendation should be first product only
                var topReccomendation = doc.querySelector('.top-recommendation span')
                if (topReccomendation) topReccomendation.innerText = index + 1

                var topReccomendationDesc = doc.querySelector('.top-reccomendation-description')
                // Product Claims Logic
                // 1) Check if there's an override for product clains by checking content in marketing fields
                let helpsReduceArray = [] // Array to store "helps reduce" logic results
                if (marketingFields.subtitle) {
                  // Split the "subtitle" content into product claims groups
                  const productClaimsGroups = marketingFields.subtitle.split('|').map((group) => group.trim())

                  // Ensure each product gets its respective claims group
                  if (productClaimsGroups[index]) {
                    helpsReduceArray = productClaimsGroups[index].split(',').map((claim) => claim.trim()) // Split each group's claims by ',' and trim spaces
                  }
                } else {
                  // 2) If not, continue with the standard logic
                  var skinTypeAnswers = e.detail.answers.find((x) => x.questionId == 124682) // "What are your top 3 skin concerns?"
                  var breakoutAnswers = e.detail.answers.find((x) => x.questionId == 114362) // "Do you ever get breakouts?"
                  // Only proceed if both answers exist
                  if (skinTypeAnswers && breakoutAnswers) {
                    // Check if it's the first product
                    if (index == 0) {
                      // For the first product, use the top 3 skin concerns
                      helpsReduceArray = skinTypeAnswers.selectedAnswers.map((obj) => obj['value']).slice(0, 3)
                    } else {
                      // For subsequent products, apply additional breakout logic
                      var breakoutAnswer = breakoutAnswers.selectedAnswers[0].value // Get breakout answer
                      var hasRedness = skinTypeAnswers.selectedAnswers.find((x) => x.value == 'Redness') // Check for "Redness"

                      if (breakoutAnswer == 'No' || breakoutAnswer == 'Full Face Breakouts') {
                        // If no breakouts or full face breakouts, take top 3 skin concerns
                        helpsReduceArray = skinTypeAnswers.selectedAnswers.map((obj) => obj['value']).slice(0, 3)
                      } else if (breakoutAnswer == 'Occasional Pimples') {
                        // If occasional pimples, prioritize "Occasional Pimples" and "Redness"
                        if (hasRedness) {
                          helpsReduceArray = ['Occasional Pimples', 'Redness']
                        } else {
                          helpsReduceArray = ['Occasional Pimples']
                        }
                      }
                    }
                  }
                }
                var helpsReduceHTML = ''
                helpsReduceArray.forEach((helpsReduce) => {
                  var bulletHTML = `<div class="tw-flex tw-items-center tw-justify-center tw-min-w-[20px] tw-max-w-[20px]"><img class="lazyload" data-src="${PRODUCT_CLAIMS_DEFINITIONS[helpsReduce]}" /></div><div>${helpsReduce}</div>`
                  helpsReduceHTML += bulletMaker(bulletHTML)
                })
                var helpsReduceHolder = doc.querySelector('.recommended-helps-reduces')
                helpsReduceHolder.innerHTML = helpsReduceHTML //clear for now

                //product info
                var productDescription = doc.querySelector('.product-description')
                if (productDescription) productDescription.innerHTML = producttext

                //product variants

                if (productInfo.options && productInfo.options.length > 0) {
                  productInfo.options.forEach((productOption) => {
                    var chooseElement = doc.querySelector('.recommended-variant-selection-text span')
                    if (chooseElement) chooseElement.innerText = productOption.name

                    productOption.values.forEach((productOptionValue, valueIndex) => {
                      var productOptionInfo = ''
                      var variantInformation = productInfo.variants.find((x) => x.title == productOptionValue)
                      var outOfStockClasses = 'slashed-selector peer-checked:slashed-selector-active'
                      if (productOption.name == 'Color') {
                        var colorSwatch = productOptionValue.replace(/\s+/g, '-').toLowerCase()
                        productOptionInfo = `<div class="tw-bg-[#FFFFFF] tw-size-12 tw-rounded-full peer-checked:tw-border peer-checked:tw-border-black tw-border tw-border-solid tw-border-[#D7D2CB] tw-flex-center tw-cursor-pointer"
                        role="button"><div class="tw-size-10 sol-swatch-${colorSwatch} tw-rounded-full ${
                          variantInformation.inventory_quantity <= 0 ? outOfStockClasses : ''
                        }" aria-label="${colorSwatch}"></div></div>`
                      } else {
                        productOptionInfo = `<div
                        class="tw-rounded-full tw-border tw-border-solid tw-border-[#D7D2CB] tw-tracking-normal tw-px-4 tw-py-3 tw-text-base peer-checked:tw-border-black tw-cursor-pointer"
                        role="button"
                      >${productOptionValue.toLowerCase()} </div>`
                      }

                      if (valueIndex == 0) {
                        if (variantInformation.inventory_quantity <= 0) {
                          doc.querySelector('.variant-availability').setAttribute('data-sold-out', 'true')
                        }
                        doc.querySelector('.selected-variant-text').innerText = productOptionValue
                      }

                      var productSwatch = `
                    <div class="tw-min-h-[36px]">
                        <label class="tw-mb-0" tabindex="${valueIndex}">
                            <input type="radio" id="${
                              variantInformation.id
                            }" class="tw-sr-only tw-peer" name="${productOption.name.toLowerCase()}" ${
                        valueIndex == 0 ? 'checked' : ''
                      } value="${productOptionValue}">
                            
                                ${productOptionInfo}
              
                        </label>
                    </div>
                    `
                      var variantForm = doc.querySelector('.recommended-variant-info form')
                      if (variantForm) variantForm.insertAdjacentHTML('beforeend', productSwatch)

                      var priceDifference = variantInformation.compare_at_price - variantInformation.price

                      // Calculate the discount percentage
                      var discountPercentage = Math.round((priceDifference / variantInformation.compare_at_price) * 100)
                      //pricing
                      var productPricing = `
                        <div class="tw-flex tw-gap tw-items-center tw-justify-center tw-gap-[10px] tw-text-[18px]/[120%] ${
                          valueIndex > 0 ? 'tw-hidden' : ''
                        } recommended-variant-pricing-index">
                            ${
                              variantInformation.compare_at_price &&
                              variantInformation.compare_at_price != variantInformation.price
                                ? '<div class="tw-font-extralight tw-line-through">$' +
                                  variantInformation.compare_at_price +
                                  '</div>'
                                : ''
                            }
                            <div class="tw-font-normal">$<span class="product-current-price">${
                              variantInformation.price
                            }</span></div>
                            <div class="tw-text-[#F93822] tw-font-normal">${
                              discountPercentage > 0 ? 'SAVE ' + discountPercentage + '%' : ''
                            }</div>
                        </div>
                        `
                      var pricingHolder = doc.querySelector('.recommended-variant-pricing')
                      if (pricingHolder) pricingHolder.insertAdjacentHTML('beforeend', productPricing)
                    })
                    //if optionvalues is only 1 hide the only option
                    if (productOption.values.length <= 1 && productOption.name != 'Color') {
                      doc.querySelector('.recommended-variant-holder').style.display = 'none'
                    }
                  })
                }
                //prod image
                var productImage = doc.querySelector('.recommended-image')
                if (productImage) {
                  var productVariantImages = productInfo.images.filter((img) => img.variant_ids && img.variant_ids.length > 0)
                  if (productVariantImages.length > 0) {
                    productVariantImages.forEach((productVariantImage, indx) => {
                      productImage.insertAdjacentHTML(
                        'beforeend',
                        `<img src="${productVariantImage.src}" class="${indx > 0 ? 'tw-hidden' : ''}" />`
                      )
                    })
                  } else {
                    productImage.insertAdjacentHTML('beforeend', `<img src="${productInfo.image.src}" class="" />`)
                  }

                  productImage.setAttribute('href', '/products/' + productInfo.handle)
                }
                //prod title
                var productTitles = doc.querySelectorAll('.recommended-title')
                productTitles.forEach((productTitle) => {
                  productTitle.innerText = productInfo.title
                })
                //prod reviews
                var productReviews = doc.querySelectorAll('.recommended-reviews')
                productReviews.forEach((productReview) => {
                  productReview.insertAdjacentHTML(
                    'beforeend',
                    `
                  <a href="/products/${productInfo.handle}">
                  <span
                    class="stamped-product-reviews-badge stamped-main-badge !tw-font-twk !tw-text-sm"
                    data-id="${productInfo.id}"
                    data-product-sku="${productInfo.handle}"
                    data-product-title="${productInfo.title}"
                    data-product-type="${productInfo.product_type}"
                    style="display: block;"
                  >
                    
                  </span>
                </a>`
                  )
                })
                //append all changed to dom
                $(node).find('.recommendation-holder').append(doc.querySelector('html').innerHTML)
                //reload third party things
                StampedFn.reloadUGC()
              }
            })
            //after section load
            //atc clicks
            node.querySelectorAll('.recommended-add-to-cart').forEach((variantAddCart) => {
              variantAddCart.addEventListener('click', function () {
                var formInfo = this.closest('.recommended-product').querySelector('form')
                var checkedInput = formInfo.querySelector('input:checked')
                var productPrice = this.closest('.recommended-product').querySelector('.product-current-price')
                if (!checkedInput || !productPrice) return
                console.log('adding recommended item to cart')
                //add to cart invoke
                window.MicroBus.emit('cart:add', {
                  variant_id: parseInt(checkedInput.id),
                  quantity: 1,
                  properties: { _quiz_kit_id: '14385', _quiz_kit_answers: quizKitAnswers },
                  toggle_side_cart: 'true',
                })

                heap.track('Quiz Kit Add To Cart', {
                  product: e.detail.name,
                  price: parseFloat(productPrice.innerText),
                  variantId: parseInt(checkedInput.id),
                })

                //post atc to presidio api
                post('https://api.quizkitapp.com/api/v1/quizzes/z6SbEN2F0/add-to-cart', {
                  price: parseFloat(productPrice.innerText),
                  variantId: parseInt(checkedInput.id),
                  source: 'quiz_result',
                  properties: { _quiz_kit_id: '14385', _quiz_kit_answers: quizKitAnswers },
                })
                  .then((res) => {
                    //console.log('presidio atc', res)
                  })
                  .catch((err) => {
                    //console.error('Could not atc for presidio', err)
                  })
              })
            })
            //variant clicks
            node.querySelectorAll('.recommended-variant-info form label').forEach((variantLabel) => {
              variantLabel.addEventListener('click', function () {
                var variantIndex = this.getAttribute('tabindex')
                //selected variant name
                this.closest('.recommended-variant-holder').querySelector('.selected-variant-text').innerText =
                  this.querySelector('input').value

                //sold out logic
                if (variantLabel.querySelector('.slashed-selector')) {
                  this.closest('.recommended-product')
                    .querySelector('.variant-availability')
                    .setAttribute('data-sold-out', 'true')
                } else {
                  this.closest('.recommended-product')
                    .querySelector('.variant-availability')
                    .setAttribute('data-sold-out', 'false')
                }

                //image variant change logic
                this.closest('.recommended-product')
                  .querySelectorAll('.recommended-image img')
                  .forEach((imageElement, imageIndex) => {
                    if (imageIndex != variantIndex) {
                      if (!imageElement.classList.contains('tw-hidden')) imageElement.classList.add('tw-hidden')
                    } else {
                      if (imageElement.classList.contains('tw-hidden')) imageElement.classList.remove('tw-hidden')
                    }
                  })

                //pricing change logic
                this.closest('.recommended-product')
                  .querySelectorAll('.recommended-variant-pricing .recommended-variant-pricing-index')
                  .forEach((pricingElement, pricingIndex) => {
                    if (pricingIndex != variantIndex) {
                      if (!pricingElement.classList.contains('tw-hidden')) pricingElement.classList.add('tw-hidden')
                    } else {
                      if (pricingElement.classList.contains('tw-hidden')) pricingElement.classList.remove('tw-hidden')
                    }
                  })
              })
            })

            //create answers into clean object to pass to heap for question/answers
            const cleanedAnswers = e.detail.answers.reduce((acc, answer) => {
              const question = answer.questionTitle
              const selectedAnswers = answer.selectedAnswers.map((sa) => sa.value).join(', ')
              acc[question] = selectedAnswers
              return acc
            }, {})

            //combine answers and keys/values into 1 object
            var quizResultsObject = Object.assign(
              {},
              {
                result: e.detail.result.name,
                result_id: e.detail.result.id,
                gave_email: e.detail.userData && e.detail.userData.email ? 1 : 0,
                product_amount: headingsObjects.length,
              },
              cleanedAnswers
            )

            //event for completion
            if (hasAnsweredQuestions) {
              heap.track('Quiz Kit Completed', quizResultsObject)
            }

            //event for viewing
            heap.track('Quiz Kit Results View', quizResultsObject)

            //discount logic
            if (e.detail.userData && e.detail.userData.email) {
              node.querySelector('.recommendation-discount-code').innerText = e.detail.discountCode
              //discount copy
              node.querySelector('.recommendation-discount-button').addEventListener('click', function (event) {
                navigator.clipboard.writeText(e.detail.discountCode)
                node.querySelector('.recommendation-discount-code').innerText = 'DISCOUNT COPIED'
                setTimeout(function () {
                  node.querySelector('.recommendation-discount-code').innerText = e.detail.discountCode
                }, 1000)
              })
              node.querySelector('.recommendation-discount').classList.remove('tw-hidden')

              var productInfo1 = e.detail.recommendedProducts.find((x) => x.id == e.detail.result.productOrders[0])

              var productInfo2 = ''
              if (e.detail.result.productOrders.length >= 2)
                productInfo2 = e.detail.recommendedProducts.find((x) => x.id == e.detail.result.productOrders[1])

              //klaviyo event
              if (hasAnsweredQuestions) {
                var _learnq = _learnq || []
                var newItems = {
                  'Quiz Kit Results Link': location.href,
                  'Quiz Results Name': e.detail.result.name,
                  'Quiz Kit Product 1 Name': productInfo1 && productInfo1.title ? productInfo1.title : '',
                  'Quiz Kit Product 1 Description': headingsObjects[0].description,
                  'Quiz Kit Product 2 Name': productInfo2 && productInfo2.title ? productInfo2.title : '',
                  'Quiz Kit Product 2 Description': headingsObjects.length > 1 ? headingsObjects[1].description : '',
                }
                waitForKlaviyo(e.detail.userData.email, newItems)
              }
            }

            //quiz retake
            node.querySelector('.retake-quiz').addEventListener('click', function () {
              heap.track('Quiz Kit Retake Quiz', {})
              document.querySelector('#layout-1-results-retake-button').click()
              //show quiz
              var quizKit = document.querySelector('[data-quiz-kit-key]')
              if (quizKit) quizKit.classList.remove('hidden-results')

              //hide results
              var quizResults = document.querySelector('.quiz-results')
              if (quizResults) quizResults.classList.add('hidden-results')

              // hide sections below this section
              mainQuizParentDiv?.classList.remove('visible-results')
            })
          })
          .catch((err) => {
            console.error('Could not get section', err)
          })
      }
    }
  })
})
